import { z } from 'zod';

export const ExperienceCreatedFrom = z.enum([
  'PRISMO',
  'POLE_EMPLOI',
  'ONBOARDING',
]);

export type ExperienceCreatedFromT = z.infer<typeof ExperienceCreatedFrom>;
